import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";
import { Link } from "react-router-dom";
import {
  faAddressBook,
  faEnvelope,
  faHouse,
  faPhone,
  faStar,
} from "@fortawesome/free-solid-svg-icons";

const Footer = () => {
  return (
    <footer>
      <Container className="mt-2 mb-5">
        <Row className="footer-row">
          <Col xs={6} md={4} className="mt-5">
            <h5>Kontakt</h5>
            <hr className="footer-hr" />
            <span class="custom-br"></span>
            <Row>
              <Col xs={2}>
                <FontAwesomeIcon icon={faHouse} className="footer-icon" />
              </Col>

              <Col xs={9} className="mt-2">
                <Link
                  to="https://www.google.com/maps?ll=50.729506,19.009631&z=13&t=m&hl=pl&gl=PL&mapclient=embed&cid=8631803499243729775"
                  target="_blank"
                >
                  <p>
                    ul.Stawowa 5 <br />
                    42-274 Konopiska <br />
                    obok Częstochowy
                  </p>
                </Link>
              </Col>
            </Row>
            <Row>
              <Col xs={2}>
                <FontAwesomeIcon icon={faPhone} className="footer-icon" />
              </Col>
              <Col xs={9} className="mt-2">
                <p>
                  <Link to="tel:889389818">+48 889 389 818</Link>
                  <br /> <Link to="tel:343282995">34 328 29 95</Link>
                </p>
              </Col>
            </Row>
            <Row>
              <Col xs={2}>
                <FontAwesomeIcon icon={faEnvelope} className="footer-icon" />
              </Col>
              <Col xs={9} className="mt-2">
                <Link to="mailto:antensat.kontakt@gmail.com">
                  <p>
                    antensat.kontakt
                    <br />
                    @gmail.com
                  </p>
                </Link>
              </Col>
            </Row>
            <Row>
              <Col xs={2}>
                <FontAwesomeIcon icon={faAddressBook} className="footer-icon" />
              </Col>
              <Col xs={9} className="mt-2">
                <Link to="/contact">
                  <p>Formularz kontaktowy</p>
                </Link>
              </Col>
            </Row>
          </Col>

          <Col xs={6} md={4} className="mt-5">
            <h5>Informacje</h5>
            <hr className="footer-hr" />
            <span class="custom-br"></span>
            <Link to="/policy">Polityka prywatności</Link>
            <br />
            <Link to="/terms">Warunki korzystania</Link>
            <br />
            <Link to="/cookies">Cookies</Link>
            <br />
            <br />
            <br />
            <h5>Oceń nas</h5>
            <hr className="footer-hr" />
            <span class="custom-br"></span>
            <p>
              Jesteś naszym klientem? <br /> Oceń nas w Google:{" "}
            </p>
            <Link
              to="https://search.google.com/local/writereview?placeid=ChIJI7RXPsG1EEcRb3Nln4xTync"
              target="_blank"
            >
              <FontAwesomeIcon icon={faStar} className="footer-icon-star" />
              <FontAwesomeIcon icon={faStar} className="footer-icon-star" />
              <FontAwesomeIcon icon={faStar} className="footer-icon-star" />
              <FontAwesomeIcon icon={faStar} className="footer-icon-star" />
              <FontAwesomeIcon icon={faStar} className="footer-icon-star" />
            </Link>
          </Col>

          <Col sm={12} md={4} className="mt-5">
            {/* Kontener dla "Dołącz do nas" i logo */}
            <div className="d-flex flex-md-column flex-row align-items-center align-items-md-start">
              {/* Lewa kolumna: "Dołącz do nas" i ikony */}
              <div className="text-start text-md-start mb-3 mb-md-0">
                <h5>Dołącz do nas</h5>
                <hr className="footer-hr" />
                <span className="custom-br"></span>
                <Link
                  to="https://www.facebook.com/antensatpl"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FontAwesomeIcon
                    icon={faFacebook}
                    className="footer-icon-big mb-2"
                  />
                </Link>
                <Link to="/">
                  <FontAwesomeIcon
                    icon={faInstagram}
                    className="footer-icon-big-gray mb-2"
                  />
                </Link>
              </div>

              {/* Prawa kolumna: Logo i tekst */}
              <div className="ms-3 ms-md-0 logo-copy">
                <Link to="/">
                  <img
                    src="/img/Logo.svg"
                    className="img-fluid logo-printly"
                    alt="Logo"
                  />
                </Link>
                <br />
                <span className="small-text">© Jarosław Golanowski 2025</span>
                <br />
                <br />
                <Link to="https://printly.net.pl" target="_blank">
                  <img
                    src="/img/logo-printly.png"
                    className="img-fluid logo-printly"
                    alt="Logo"
                  />
                </Link>
                <br />
                <span className="small-text">
                  Potrzebujesz usług druku wielkoformatowego? Odwiedź{" "}
                  <Link to="https://printly.net.pl" target="_blank">
                    printly
                  </Link>!
                </span>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};
export default Footer;
